import { useEffect } from "react";
import { Modal } from "antd";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { PurchaseLicenseCodeSelector } from "../../MySite/Components/PurchaseLicenseCodeSelector";

const LicenseItemModal = ({
  open,
  setOpen,
  licenseId,
  editingItem,
  existingItems,
  setEditingItem,
  itemsRefetch,
}) => {
  const isEdit = editingItem?.ItemNo != null;

  const itemsUrl = `${process.env.REACT_APP_API_URL}/api/licenses/${licenseId}/items/`;
  const { error: postError, postData } = usePost(itemsUrl);
  const { error: putError, putData } = usePut(itemsUrl);

  useEffect(() => {
    const error = postError || putError;
    if (error) {
      openErrorNotification(
        error?.response?.data?.message || "Something went wrong",
      );
    }
  }, [postError, putError]);

  const handleClose = () => setOpen(false);

  const onPick = async (code) => {
    if (isEdit && Number(code.CodeNo) === Number(editingItem.CodeNo)) {
      return true;
    }
    const payload = { CodeNo: Number(code.CodeNo) };
    const result = isEdit
      ? await putData(payload, `${itemsUrl}${editingItem.ItemNo}/`)
      : await postData(payload);
    if (result == null) return false;
    openConfirmNotification("Success");
    itemsRefetch?.();
    return true;
  };

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      // Clearing editingItem mid close-animation would switch to add mode while fading out.
      afterClose={() => setEditingItem(null)}
      footer={null}
      width={1000}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <LicenseIcon className="text-[18px] text-black " />
          <span className="text-[14px] font-['Poppins'] text-black  ml-2">
            {isEdit ? "Edit license item" : "Add license item"}
          </span>
        </div>
      }
    >
      {licenseId ? (
        <PurchaseLicenseCodeSelector
          existingItems={existingItems}
          editingItem={editingItem}
          ownerLabel="license"
          onPick={onPick}
          onCancel={handleClose}
        />
      ) : null}
    </Modal>
  );
};

export default LicenseItemModal;
